// ProductTable.js
import React, { useState } from "react";
import { useTable } from "react-table";
import deleteicon from "../../../assets/Order/Delete.svg";
import { Input } from "antd";
import { t } from "i18next";

const StockTransferProductTable = ({
    productList,
    handleProductChange,
    handleDeleteProduct,
    disabled,
    fromStoreName,
    subStoreName,
}) => {


    const columns = React.useMemo(
        () => [
            {
                Header: t("Barcode"),
                accessor: "barcode",
                width: '13%',
                Cell: ({ value }) => <span className="block">{value}</span>,
            },
            {
                Header: t("Product Name"),
                accessor: "name",
                width: '23%',
                Cell: ({ value }) => <span className="block">{value}</span>,
            },
            {
                Header: t("UOM"),
                accessor: "uom",
                width: '7%',
                Cell: ({ value }) => <span className="block">{value}</span>,
            },
            // {
            //     Header: t("Current Inventory (Master Store)"),
            //     accessor: "parent_store_stock",
            //     Cell: ({ value }) => <span className="block">{value}</span>,
            // },
            // {
            //     Header: t("Current Inventory (Sub-Store)"),
            //     accessor: "child_store_stock",
            //     Cell: ({ value }) => <span className="block">{value}</span>,
            // },
            {
                Header: t("Cost Price"),
                accessor: "parent_store_cost_price",
                width: '10%',
                Cell: ({ value }) => <span className="block">EGP {value || '0'}</span>,
            },
            {
                Header: t("Sale Price"),
                accessor: "parent_store_sale_price",
                width: '7%',
                Cell: ({ value }) => <span className="block"> EGP {value || '0'}</span>,
            },
            {
      Header: t("Transfer CP & SP"),
      accessor: "is_update_cp_sp",
      disableSortBy: true,
      Cell: ({ row }) => {
        const isActive = row.original.is_update_cp_sp;

        return (
          <label className="flex cursor-pointer select-none items-center">
            <div className="relative">
              <input
                type="checkbox"
                checked={isActive}
                onChange={() =>
                  handleProductChange(
                                        row.index,
                                        "is_update_cp_sp",
                                        !isActive
                                    )
                                
                }
                className="sr-only"
              />

              <div
                className={`block h-6 w-12 rounded-full ${
                  isActive ? "bg-green-500" : "bg-gray-500"
                }`}
              />

              <div
                className={`absolute left-1 top-1 h-4 w-5 rounded-full bg-white transition-transform ${
                  isActive ? "translate-x-full" : ""
                }`}
              />
            </div>
          </label>
        );
      },
    },
            {
                Header: `${t("Current Inventory")} (${fromStoreName || t("Master Store")})`,
                accessor: "parent_store_stock",
                width: '12%',
                Cell: ({ value }) => <span className="block">{value}</span>,
            },
            {
                Header: `${t("Current Inventory")} (${subStoreName || t("Sub-Store")})`,
                accessor: "child_store_stock",
                width: '12%',
                Cell: ({ value }) => <span className="block">{value}</span>,
            },
            {
                Header: t("Transfer Qty"),
                accessor: "purchaseQty",
                width: '10%',
                Cell: ({ row }) => {
                    const [localPurchaseQty, setLocalPurchaseQty] = useState(
                        row.original.purchaseQty
                    );
                    const uom = row.original.uom;

                    return (
                        <div>
                            <Input
                                type="text"
                                className="w-20 text-left" // 👈 Narrow + start aligned
                                value={localPurchaseQty}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    if (value === "-" || value === "-0") {
                                        setLocalPurchaseQty("-");
                                        return;
                                    }
                                    if (value === "-" && localPurchaseQty === "0") {
                                        setLocalPurchaseQty("-");
                                        return;
                                    }

                                    const isInteger = /^-?\d*$/;
                                    const isDecimal = /^-?\d*\.?\d{0,7}$/;
                                    if (
                                        (uom === "Units" && isInteger.test(value)) ||
                                        (uom !== "Units" && isDecimal.test(value))
                                    ) {
                                        setLocalPurchaseQty(value);
                                    }
                                }}
                                onBlur={() =>
                                    handleProductChange(
                                        row.index,
                                        "purchaseQty",
                                        localPurchaseQty || 0
                                    )
                                }
                                disabled={disabled}
                                maxLength={8}
                            />
                        </div>
                    );
                },
            },
            {
                Header: `${t("Remaining Qty")} (${fromStoreName || t("Master Store")})`,
                accessor: "remaining_qty",
                width: '14%',
                Cell: ({ row }) => {
                    const masterStock = row.original.parent_store_stock || 0;
                    const transferQty = Number(row.original.purchaseQty) || 0;
                    const remaining = masterStock - transferQty;

                    return (
                        <span className={`${remaining < 0 ? "text-red-500" : ""}`}>
                            {remaining >= 0 ? remaining : 0}
                        </span>
                    );
                },
            },
            {
                Header: " ",
                accessor: "actions",
                width: '5%',
                Cell: ({ row }) => (
                    <div>
                        <img
                            className={`mx-4 h-4 w-4 cursor-pointer ${disabled ? "opacity-50 cursor-not-allowed" : ""
                                }`}
                            src={deleteicon}
                            alt="deleteicon"
                            onClick={() => !disabled && handleDeleteProduct(row.index)}
                        />
                    </div>
                ),
            },
        ],
        [handleDeleteProduct, fromStoreName, subStoreName]
    );

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
        useTable({
            columns,
            data: productList,
        });

    return (
        <div className="overflow-x-auto mt-5 scrollbar-thin">
            <table
                {...getTableProps()}
                className="sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] min-h-auto shadow-xl rounded-lg overflow-hidden"
            >
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr
                            {...headerGroup.getHeaderGroupProps()}
                            className="bg-[#78CFEC66] text-xs font-semibold rounded-lg"
                        >
                            {headerGroup.headers.map((column) => (
                                <th
                                    {...column.getHeaderProps()}
                                      style={{ width: column.width }}
                                     className="px-2 py-3 ps-2 text-start text-xs font-semibold"

                                >
                                    <div className="max-w-[140px] break-words leading-tight">
    {column.render("Header")}
  </div>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody
                    {...getTableBodyProps()}
                    className="bg-[#F7F9FD] border-t border-b border-gray-300"
                >
                    {rows.map((row) => {
                        prepareRow(row);
                        const isStockUnavailable = row.original.is_stock_available_on_master === false;
                        return (
                            // <tr {...row.getRowProps()} className="border-b border-gray-300">
                            <tr
                                {...row.getRowProps()}
                                className={`border-b border-gray-300 
          ${isStockUnavailable ? "bg-rose-50 border border-rose-200" : ""} // 🚨 Highlight unavailable
        `}
                            >
                                {row.cells.map((cell, index) => (
                                    <td
                                        {...cell.getCellProps()}
                                          style={{ width: cell.column.width }}  
                                        className={`
                      px-2 py-3 text-xs text-start
                      ${index === 0 ? "ps-4" : ""}
                      ${index === row.cells.length - 1 ? "rounded-s-lg" : ""}
                    `}
                                    >
                                        {cell.render("Cell")}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default StockTransferProductTable;
